import React from 'react';
import { Container, Box, Paper, Typography } from '@mui/material';
import { LoginForm } from './components/LoginForm';
import { LoginAlerts } from './components/LoginAlerts';

const Login = () => {
  return (
    <Container 
      component="main" 
      maxWidth="xs"
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        py: 4,
        minHeight: '100svh',
      }}
    >
      <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, sm: 4 },
              width: '100%',
              bgcolor: 'background.paper',
              borderRadius: 3,
              border: 1,
              borderColor: 'divider',
              boxShadow: '0 24px 70px rgba(0, 0, 0, 0.32)',
            }}
          >
            <Typography
              component="h1"
              variant="h4"
              gutterBottom
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                mb: 0.5,
              }}
            >
              Вход в систему
            </Typography>
            <Typography color="text.secondary" mb={2.5}>
              Используйте рабочую учётную запись Sprut Admin
            </Typography>
            <LoginAlerts />
            <LoginForm />
          </Paper>
      </Box>
    </Container>
  );
};

export default Login;
